module.exports = __webpack_public_path__ + "img/BINDI 5 RED.437f90d.svg";